import {
  SetStratBoundsReq,
  StratBoundsReq,
  StratBoundsDef,
} from "../type/strat-bounds-def";

export class StratBoundsAdapter {
  static toUpdateInputDTO(req: SetStratBoundsReq): any {
    return {
      label: req.label,
      levels: req.levels || [],
    };
  }

  static toInputDTO(req: StratBoundsReq): any {
    return req.label;
  }

  static toOutputDTO(res: any): StratBoundsDef {
    return res;
  }
}
